import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";


import { Link, useNavigate } from "react-router-dom";

// import images
import profileImg from "../../assets/images/profile-img.png";
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const Register = props => {

  //meta title
  document.title = "Definite Assurance | Registration";

  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [identification, setIdentification] = useState('');
  const [krapin, setKRAPIN] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmpassword] = useState('');
  const [buttonText, setButtontext] = useState('Register Now')
  const [regions, setRegions] = useState([])
  const [selectedRegion, setSelectedregion] = useState('')
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const company = 'Definite'
  
    useEffect(()=>{
    const getCredentials =async()=>{
      const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
      const data = await res.json();
      const {Username, Password} = data;
      const cred = btoa(`${Username}:${Password}`)
      setCredentials(btoa(`${Username}:${Password}`))
      setIsauth(true)
  
  
    }
    getCredentials()
  
    },[])


  const register =async()=>{
    if(name && email && phone && identification && krapin && password && confirmPassword){
      if(password == confirmPassword){
        setButtontext('Please wait...');
        const res = await fetch(`https://digitalapi.definiteassurance.com/api/register`,{
          method:"POST",
          headers:{
            "Content-Type":"application/json"
          },
          body:JSON.stringify({name,email,phone,identification,krapin,password,selectedRegion}),
          credentials:"include"
        })

        const data = await res.json();
        const {success,exists} = data;
        if(success && !exists){
          setButtontext('Register Now')
          toast.success("Account successfully registered")
          navigate('/login')
        }
        else if(!success && exists){
          setButtontext('Register Now')
          toast.error("Account already exists")
        }
        else{
          setButtontext('Register Now')
          toast.error('Something went wrong! Please try again later')
        }



      }
      else{
        toast.error('Passwords do no match')
      }
    }
    else{
      toast.error('All fields marked * are required!')
    }
  }

  useEffect(()=>{
    const getRegions =async()=>{
      const res  = await fetch(`https://digitalapi.definiteassurance.com/api/getRegions`);
      const data = await res.json();
      setRegions(data)
    }

    getRegions()
  },[])




  

  return (
    <div className="loginBody2">
      <div className="regContainer">
     <div className="regBanner">
      <img src="/insurancebanner.jpg" alt="" className="insuranceBanner" />
     </div>

      <div className="registrationContainer" >
        <div className="regForm">

       
      <ToastContainer />
        <Container>
          <Row >
            <Col >
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle" id="loginTop2">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                      <img src="/definitelogo.png" alt="" className="loginLogo" />
                      
                        <p className="loginDesc">Get a free account now.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">

                  <div className="p-2">
                    
   
                     
                      <div className="entryRow">
                      <div className="mb-3" id='fieldInputs'>
                        <Label className="form-label">Name*</Label>
                        <Input
                          id="name"
                          name="text"
                          className="form-control"
                          placeholder="Enter your name"
                          type="text"
                          onChange={(e)=>{setName(e.target.value)}}

                        />
                      </div>

                      <div className="mb-3" id='fieldInputs'>
                        <Label className="form-label">Email*</Label>
                        <Input
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={(e)=>{setEmail(e.target.value)}}

                        />
                      </div>


                      </div>
                    <div className="entryRow">
                    
                      

                      <div className="mb-3"  id='fieldInputs'>
                        <Label className="form-label">Phone number*</Label>
                        <Input
                          name="phone"
                          type="text"
                          placeholder="0712345678"
                          onChange={(e)=>{setPhone(e.target.value)}}
                        />

                      </div>

                       <div className="mb-3"  id='fieldInputs'>
                        <Label className="form-label">KRA PIN*</Label>
                        <Input
                          name="krapin"
                          type="text"
                          placeholder="KRA PIN"
                          onChange={(e)=>{setKRAPIN(e.target.value)}}
                        />

                      </div>

                     

                    </div>

                    <div className="entryRow">
                   

                      <div className="mb-3"  id='fieldInputs'>
                        <Label className="form-label">IRA License Number*</Label>
                        <Input
                          name="identification"
                          type="text"
                          placeholder="IRA License Number"
                          onChange={(e)=>{setIdentification(e.target.value)}}
                        />

                      </div>

                       <div className="mb-3" id='fieldInputs'>
                        <Label className="form-label">SELECT REGION</Label>
                        <Input
                          name="region"
                          type="select"
                          onChange={(e) => { setSelectedregion(e.target.value) }}
                        >
                          <option disabled selected>SELECT REGION</option>
                          {regions.map((val,index)=>{
                            return(
                              <option key={index} value={val.RegionName}>{val.RegionName}</option>
                            )
                          })}

                        
                        </Input>
                      </div>
                      
                    </div>
                    <div className="entryRow"  >
                    <div className="mb-3" id='fieldInputs'>
                        <Label className="form-label">Password*</Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={(e)=>{setPassword(e.target.value)}}
                        />

                      </div>
                      <div className="mb-3"  id='fieldInputs'>
                        <Label className="form-label">Confirm Password*</Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder="Confirm Password"
                          onChange={(e)=>{setConfirmpassword(e.target.value)}}
                        />

                      </div>

                    </div>
                     


                     

                    <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          onClick={register}
                          id="loginButton"
                        >
                          {buttonText}
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          By registering you agree to the Definite Assurance Company Ltd{" "}
                          <Link to="/terms-of-use" style={{color:'#eb2229'}}>
                            Terms of Use
                          </Link>
                        </p>
                      </div>
                      <p style={{textAlign:'center'}}>
                  Already have an account ?{" "} <Link  to="/login" style={{color:'#eb2229'}} >
                    {" "}
                    Login
                  </Link>{" "}
                </p>
                
                  </div>
                </CardBody>
              </Card>
              </Col>
              </Row>
              
              <div className="mt-5 text-center">
                
                <p style={{color:'#fff'}}>
                  © {new Date().getFullYear()} Definite Agents Portal. Crafted by Vic Creates
                </p>
              </div>

        </Container>
      </div>
      </div>
      </div>

    </div>
  );
};

export default Register;
